module.exports = __webpack_public_path__ + "static/media/pencil-ruler.5a5d3ef5.svg";